import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react'
import { useLocation } from 'react-router-dom'
import mapValues from 'lodash/mapValues'
import queryString from 'query-string'
import { callApi, ENDPOINTS } from 'utils/api/callApi'

enum FEATURE_FLAGS {
  fmsUpdatedAmPodOptions = 'fmsUpdatedAmPodOptions',
  fmsUpdatedBrokerPodOptions = 'fmsUpdatedBrokerPodOptions',
  enableTruckerToolsLoadBoardPostStatusInMP = 'enableTruckerToolsLoadBoardPostStatusInMP',
  mpQrConfirmationModal = 'mpQrConfirmationModal',
  fmsFrontChat = 'fmsFrontChat',
  fmsPrebookingLoadDetailsMap = 'fmsPrebookingLoadDetailsMap',
  fmsSkipW9 = 'fmsSkipW9',
  fmsSubmitSafetyLetter = 'fmsSubmitSafetyLetter',
  enableEinRule = 'enableEinRule',
  enableCarrierHomepageForAll = 'enableCarrierHomepageForAll',
  amazonConnectClickToCall = 'amazonConnectClickToCall',
  enableFraudValidation = 'enableFraudValidation',
  enableNewCarrierAppHomepage = 'enableNewCarrierAppHomepage',
  fmsOnboardingForm = 'fmsOnboardingForm',
  mpNavigationBarUpdate = 'mpNavigationBarUpdate',
  carrierAppW9RestrictUpload = 'carrierAppW9RestrictUpload',
  sqtObjectiveFour = 'sqtObjectiveFour',
  lockStormDashboardFrontend = 'lockStormDashboardFrontend',
  highwayCarrierApplicationFlow = 'highwayCarrierApplicationFlow',
  enableCarrierCompIncentive = 'enableCarrierCompIncentive',
  enableCarrierOptionPageSize = 'enableCarrierOptionPageSize',
  autobiddersConfigurationPage = 'autobiddersConfigurationPage',
  motorCarrierProfileShowDiverseCarrierCertificationsCard = 'motorCarrierProfileShowDiverseCarrierCertificationsCard',
  highRiskLoadsFlag = 'highRiskLoadsFlag',
  enableFmsGraphqlRecs = 'enableFmsGraphqlRecs',
  fmsOnboardingCarrierMutation = 'fmsOnboardingCarrierMutation',
  motorCarrierProfileShowLoadPreferencesCard = 'motorCarrierProfileShowLoadPreferencesCard',
  motorCarrierProfileHideFmsNav = 'motorCarrierProfileHideFmsNav',
  motorCarrierProfileShowFmsTag = 'motorCarrierProfileShowFmsTag',
  motorCarrierProfileShowSmartWayCarrierCard = 'motorCarrierProfileShowSmartWayCarrierCard',
  motorCarrierProfileShowSavedLanesCard = 'motorCarrierProfileShowSavedLanesCard',
  mpMarketInsights = 'mpMarketInsights',
  disableStarkShipmentCreate = 'disableStarkShipmentCreate',
  mpRelayAccessorials = 'mpRelayAccessorials',
  enableRogersShipmentCloning = 'enableRogersShipmentCloning',
  newShipperTransfixTeamForm = 'newShipperTransfixTeamForm',
  mpTrueRatePlus = 'mpTrueRatePlus',
  mpShipperPage = 'mpShipperPage',
  enableRogersShipmentCreateForm = 'enableRogersShipmentCreateForm',
  enableAwardedLaneListingDetails = 'enableAwardedLaneListingDetails',
  enableRogersCarrierForm = 'enableRogersCarrierForm',
  removeSchedulingTab = 'removeSchedulingTab',
  laneAgreements = 'laneAgreements',
  tmsDriverMap = 'tmsDriverMap',
  dropTrailerNumber = 'dropTrailerNumber',
  separateCoverageRoute = 'separateCoverageRoute',
  reOfferShipment = 'reOfferShipment',
  shipmentTonu = 'shipmentTonu',
  testFlag = 'testFlag',
  trackingSegment = 'trackingSegment',
  loadComments = 'loadComments',
  loadsListFunctionalStatusTag = 'loadsListFunctionalStatusTag',
  highwayMilestoneFourComplianceTab = 'highwayMilestoneFourComplianceTab',
  stagingRulesDebugger = 'stagingRulesDebugger',
  highwayMilestoneThreeInsuranceCard = 'highwayMilestoneThreeInsuranceCard',
  loadDetailsActivity = 'loadDetailsActivity',
  fpQuickbooksIntegration = 'fpQuickbooksIntegration',
  fpAddReloads = 'fpAddReloads',
  fpCarrierPortal = 'fpCarrierPortal',
  fmsPaymentStatus = 'fmsPaymentStatus',
  marketplaceUserTrackingTab = 'marketplaceUserTrackingTab',
  confettis = 'confettis',
  fmsBcaIncreaseUploadLimit = 'fmsBcaIncreaseUploadLimit',
  fmsTeamMembersShowDriverSmsOptInStatus = 'fmsTeamMembersShowDriverSmsOptInStatus',
  fmsOnboarding = 'fmsOnboarding',
  fmsOffersPage = 'fmsOffersPage',
  fmsOffersPageExpiredAndDeclined = 'fmsOffersPageExpiredAndDeclined',
  fmsAccountDeletion = 'fmsAccountDeletion',
  fmsBookLoadsMobile = 'fmsBookLoadsMobile',
  fmsBookLoadsOptLanes = 'fmsBookLoadsOptLanes',
  fmsDedicatedLaneListingDetails = 'fmsDedicatedLaneListingDetails',
  fmsTrackingConversion = 'fmsTrackingConversion',
  fmsSavedShipmentSearch = 'fmsSavedShipmentSearch',
  fmsShipmentMaxAgeFilter = 'fmsShipmentMaxAgeFilter',
  fmsReloadsModal = 'fmsReloadsModal',
  fmsCmSavedShipmentSearch = 'fmsCmSavedShipmentSearch',
  fmsLaneRecommendations = 'fmsLaneRecommendations',
  fmsShareAvailableTrucks = 'fmsShareAvailableTrucks',
  fmsFleetMobileView = 'fmsFleetMobileView',
  isNewCarrierOptionFilterEnable = 'isNewCarrierOptionFilterEnable',
  fmsAutomatedStatusUpdates = 'fmsAutomatedStatusUpdates',
  fmsSideNav = 'fmsSideNav',
  fmsTargetDedicatedShipments = 'fmsTargetDedicatedShipments',
  dedicatedLanesPage = 'dedicatedLanesPage',
  dedicatedLanesPageCapacity = 'dedicatedLanesPageCapacity',
  dedicatedLanesPageSms = 'dedicatedLanesPageSms',
  rfpLaneMatchDownload = 'rfpLaneMatchDownload',
  fmsEnableTrackingButton = 'fmsEnableTrackingButton',
  fmsELDTracking = 'fmsELDTracking',
  newLaneAlerts = 'newLaneAlerts',
  refreshNormFile = 'refreshNormFile',
  mpNotificationsCenter = 'mpNotificationsCenter',
  mpRmsRepricedRates = 'mpRmsRepricedRates',
  mpRmsTrueRates = 'mpRmsTrueRates',
  mpAcceptRejectAutomation = 'mpAcceptRejectAutomation',
  mpAcceptRejectConfiguration = 'mpAcceptRejectConfiguration',
  newRoutingGuides = 'newRoutingGuides',
  redirectToNewShipmentDetails = 'redirectToNewShipmentDetails',
  displayStrategicBuyRate = 'displayStrategicBuyRate',
  newShipmentDetailsPageUrls = 'newShipmentDetailsPageUrls',
  shipmentDispatch = 'shipmentDispatch',
  shipmentDetailsTenderLive = 'shipmentDetailsTenderLive',
  displayGeneralCardReport = 'displayGeneralCardReport',
  shipmentCover = 'shipmentCover',
  shipmentDetailsCancel = 'shipmentDetailsCancel',
  shipmentDetailsAcceptReject = 'shipmentDetailsAcceptReject',
  shipmentDetailsSMS = 'shipmentDetailsSMS',
  mpAuthenticationProvider = 'mpAuthenticationProvider',
  shipmentDocumentsCard = 'shipmentDocumentsCard',
  shipmentAccesorials = 'shipmentAccesorials',
  fmsStatusUpdateToggle = 'fmsStatusUpdateToggle',
  schedulingTab = 'schedulingTab',
  viewFmsSms = 'viewFmsSms',
  editingAppointment = 'editingAppointment',
  shipmentDetailsOptions = 'shipmentDetailsOptions',
  showLookerShipmentLogs = 'showLookerShipmentLogs',
  shipmentSidePanelTenderTrackingInfo = 'shipmentSidePanelTenderTrackingInfo',
  mpShipperFuelSchedule = 'mpShipperFuelSchedule',
  rogersAuthPages = 'rogersAuthPages',
  tmsNewHomePage = 'tmsNewHomePage',
  tmsNewHomePageModal = 'tmsNewHomePageModal',
  shipmentGeneralAccountingCardEdit = 'shipmentGeneralAccountingCardEdit',
  editShipmentAccessorials = 'editShipmentAccessorials',
  displayMatchingShipmentsCard = 'displayMatchingShipmentsCard',
  tmsSupportCAMXAddresses = 'tmsSupportCAMXAddresses',
  invoicesDocuments = 'invoicesDocuments',
  podDocuments = 'podDocuments',
  carrierAppNewW9Upload = 'carrierAppNewW9Upload',
  shipmentDetailsRoutingGuide = 'shipmentDetailsRoutingGuide',
  shipmentDetailsPendingAppointments = 'shipmentDetailsPendingAppointments',
  shipmentDetailsEditVerticalProgressList = 'shipmentDetailsEditVerticalProgressList',
  cloneShipmentButton = 'cloneShipmentButton',
  fmsLoadDetailsInformation = 'fmsLoadDetailsInformation',
  tmsSetupGuide = 'tmsSetupGuide',
  fmsDetentionRequest = 'fmsDetentionRequest',
  tmsOnboarding = 'tmsOnboarding',
  tmsCreditCheck = 'tmsCreditCheck',
  tmsInsightsPage = 'tmsInsightsPage',
  tmsInsightsDataDownload = 'tmsInsightsDataDownload',
  tmsInsightsFacilities = 'tmsInsightsFacilities',
  tmsInsightsOverview = 'tmsInsightsOverview',
  invoiceAttachmentDocuments = 'invoiceAttachmentDocuments',
  scaleTicketDocuments = 'scaleTicketDocuments',
  miscDocuments = 'miscDocuments',
  fmsCombinePodFiles = 'fmsCombinePodFiles',
  rearrangeStopsButton = 'rearrangeStopsButton',
  deleteShipmentStops = 'deleteShipmentStops',
  amQuotingManualQuoteType = 'amQuotingManualQuoteType',
  addStopButton = 'addStopButton',
  fmsDeleteBid = 'fmsDeleteBid',
  podApprovalButton = 'podApprovalButton',
  extendedScorecard = 'extendedScorecard',
  uncancelShipment = 'uncancelShipment',
  newFacilityPageLink = 'newFacilityPageLink',
  dedicatedLanesContactModal = 'dedicatedLanesContactModal',
  dedicatedLanesExpiringSoonTag = 'dedicatedLanesExpiringSoonTag',
  fmsGuidedBidding = 'fmsGuidedBidding',
  tmsFoodGrade = 'tmsFoodGrade',
  tmsBulkUpload = 'tmsBulkUpload',
  tmsRSOShipperCompliance = 'tmsRSOShipperCompliance',
  tmsTrailerNumberDriverName = 'tmsTrailerNumberDriverName',
  tmsMileage = 'tmsMileage',
  tmsMultiPODs = 'tmsMultiPODs',
  tmsAssignedTo = 'tmsAssignedTo',
  tmsDraftShipmentNotes = 'tmsDraftShipmentNotes',
  tmsTransfixTagNote = 'tmsTransfixTagNote',
  homePageUpdates = 'homePageUpdates',
  graphqlBatching = 'graphqlBatching',
  requestComplianceApproval = 'requestComplianceApproval',
  editAdditionalCarrierInfo = 'editAdditionalCarrierInfo',
  fmsCounterBidding = 'fmsCounterBidding',
  faPastPickupDateAdjustment = 'faPastPickupDateAdjustment',
  tmsIntermodal = 'tmsIntermodal',
  bumbleBeeDDigest = 'bumbleBeeDDigest',
  tmsShipperReports = 'tmsShipperReports',
  showClaimsAllowBillingInvoicing = 'showClaimsAllowBillingInvoicing',
  carrierAppMilestoneFiveCarrierUpload = 'carrierAppMilestoneFiveCarrierUpload',
  fmsMarketInsightsFcfsLabel = 'fmsMarketInsightsFcfsLabel',
  smsTranslate = 'smsTranslate',
  smsStarkUiChanges = 'smsStarkUiChanges',
  mapAndPingsTab = 'mapAndPingsTab',
  fmsDeclineBid = 'fmsDeclineBid',
  removeTonuServiceable = 'removeTonuServiceable',
  removeTonuFromInvoiceSent = 'removeTonuFromInvoiceSent',
  unDeliverShipmentsButtonNewConditions = 'unDeliverShipmentsButtonNewConditions',
  detentionNewMap = 'detentionNewMap',
  detentionPageAddToggle = 'detentionPageAddToggle',
  detentionPageShowIssues = 'detentionPageShowIssues',
  detentionPageShowAccessorialPolicy = 'detentionPageShowAccessorialPolicy',
  fmsMarketInsightsPopularShipmentsLabel = 'fmsMarketInsightsPopularShipmentsLabel',
  fmsMarketInsightsGreatRateLabel = 'fmsMarketInsightsGreatRateLabel',
  useRayTracer = 'useRayTracer',
  usePcMilerLocation = 'usePcMilerLocation',
  showStarkShipmentLogsLink = 'showStarkShipmentLogsLink',
  shipperDetailsSpf = 'shipperDetailsSpf',
  editingInOutTimesPostDelivered = 'editingInOutTimesPostDelivered',
  tmsCostPlus = 'tmsCostPlus',
  carrierScorecardPage = 'carrierScorecardPage',
  fmsEquipmentListingPage = 'fmsEquipmentListingPage',
  canEditApprovedDetention = 'canEditApprovedDetention',
  stopTrailerRow = 'stopTrailerRow',
  tmsShipmentNotes = 'tmsShipmentNotes',
  fpTrailerOnRateConPage = 'fpTrailerOnRateConPage',
  issueSLAsAndEscalation = 'issueSLAsAndEscalation',
  costInStarkDashboardStrategyInformation = 'costInStarkDashboardStrategyInformation',
  stormStrategyManagement = 'stormStrategyManagement',
  mpStormErrorHandling = 'mpStormErrorHandling',
  stormAwardManagement = 'stormAwardManagement',
  rfpLanesImportExportEnabled = 'rfpLanesImportExportEnabled',
  mpStormLaneRefresh = 'mpStormLaneRefresh',
  dropTrailerTimestamps = 'dropTrailerTimestamps',
  maskCmtRates = 'maskCmtRates',
  mpDropTrailer = 'mpDropTrailer',
  enableOooManagement = 'enableOooManagement',
  enableNewAddFacilityModal = 'enableNewAddFacilityModal',
  allowEarlyTimestampEditing = 'allowEarlyTimestampEditing',
  carrierTrailerManagement = 'carrierTrailerManagement',
  driverLedLocation = 'driverLedLocation',
  dedicatedLanesBidEventV2 = 'dedicatedLanesBidEventV2',
  dropTrailerPool = 'dropTrailerPool',
  shipperRateSourcing = 'shipper_rate_sourcing',
  multiStopQuotingAmqt = 'multiStopQuotingAmqt',
  moveMapAndPings = 'moveMapAndPings',
  loadAssignmentAvailability = 'loadAssignmentAvailability',
  spotQuoteTool = 'spotQuoteTool',
  movePodWarningToTopInCarrierApp = 'movePodWarningToTopInCarrierApp',
  enableSavedLanesMP = 'enableSavedLanesMP',
  mpConnectFuelToShipments = 'mpConnectFuelToShipments',
  spcpStepPricing = 'spcpStepPricing',
  fmsRedirectUsersAdminApproval = 'fmsRedirectUsersAdminApproval',
  sqtFuelSurcharge = 'sqtFuelSurcharge',
  sqtAppliedRulesData = 'sqtAppliedRulesData',
  fmsRejectionReasonPOD = 'fmsRejectionReasonPOD',
  whoElseIsHere = 'whoElseIsHere',
  fmsOneTimeSmsLoadShare = 'fmsOneTimeSmsLoadShare',
  useNewStateTagsMp = 'useNewStateTagsMp',
  shipperAppTrueRateBookingExperience = 'shipperAppTrueRateBookingExperience',
  shipperAppTrueRateShipmentDetails = 'shipperAppTrueRateShipmentDetails',
  shipperAppTrueRateReporting = 'shipperAppTrueRateReporting',
  checkIsUserValidationChecked = 'checkIsUserValidationChecked',
  fmsDriver2LoadShare = 'fmsDriver2LoadShare',
  mpRepGroups = 'mpRepGroups',
  fmsDriverTwoLoadShare = 'fmsDriverTwoLoadShare',
  newCarrierProfileSidebar = 'newCarrierProfileSidebar',
  shipperAppRFPCreation = 'shipperAppRFPCreation',
  shipperAppRFPO4 = 'shipperAppRFPO4',
  shipperAppRFPO5 = 'shipperAppRFPO5',
  mpRelatedShipments = 'mpRelatedShipments',
  fmsHighwayCarrierOnboarding = 'fmsHighwayCarrierOnboarding',
  fmsHighwayMilestoneFour = 'fmsHighwayMilestoneFour',
  displayFacilityName = 'displayFacilityName',
  hideFacilityAddress = 'hideFacilityAddress',
  shipperBTFFlexibleRules = 'shipperBTFFlexibleRules',
  shipperAppGraphQL = 'shipperAppGraphQL',
  useBrokerPods = 'useBrokerPods',
  mpFacilityVendorContacts = 'mpFacilityVendorContacts',
  useNewCarrierStatusTags = 'useNewCarrierStatusTags',
  mpVendorList = 'mpVendorList',
  mpFacilityPagination = 'mpFacilityPagination',
  highwayMilestoneTwoCarrierStatusEditStatus = 'highwayMilestoneTwoCarrierStatusEditStatus',
  mpEliminateDuplicates = 'mpEliminateDuplicates',
  mpEmailSchedulingVisibility = 'mpEmailSchedulingVisibility',
  refactoredSavedLanesCreateAndUpdate = 'refactoredSavedLanesCreateAndUpdate',
  carrierAppHighwayButtonSync = 'carrierAppHighwayButtonSync',
  mpTaskSnoozing = 'mpTaskSnoozing',
  mpNewSchedulerPage = 'mpNewSchedulerPage',
  mpIssuePageListSaveSearches = 'mpIssuePageListSaveSearches',
  mpSOPLinks = 'mpSOPLinks',
  mpShipmentIssueAutomation = 'mpShipmentIssueAutomation',
  mpShipmentIssueAutomationM2 = 'mpShipmentIssueAutomationM2',
  mpShipmentIssueAutomationM4 = 'mpShipmentIssueAutomationM4',
  mpShipmentIssueAutomationM5 = 'mpShipmentIssueAutomationM5',
  stormUrlAwardedLanes = 'stormUrlAwardedLanes',
  useGlobalDefinitionOfTracking = 'useGlobalDefinitionOfTracking',
  displayRfpStatusTag = 'displayRfpStatusTag',
  highwayArchivedCerts = 'highwayArchivedCerts',
  syncHighwayWithMarketplace = 'syncHighwayWithMarketplace',
  hideDeleteBcaButton = 'hideDeleteBcaButton',
  showDeprecatedBcas = 'showDeprecatedBcas',
  oopAutoIssueCreate = 'oopAutoIssueCreate',
  mpMergeBulkFacilities = 'mpMergeBulkFacilities',
  suggested_appointments_persist_to_appointment = 'suggested_appointments_persist_to_appointment',
  mpStepsToResolve = 'mpStepsToResolve',
  allowNewMyLoadsTable = 'allowNewMyLoadsTable',
  mpArchiveVendors = 'mpArchiveVendors',
  carrierPortalMaintenance = 'carrierPortalMaintenance',
  fpQrConfirmationModal = 'fpQrConfirmationModal',
  carrier_accessorial_approval_flow = 'carrier_accessorial_approval_flow',
  mpRolledShipmentStatus = 'mpRolledShipmentStatus',
  shipperAppManualCloseBid = 'shipperAppManualCloseBid',
  mpShipperPreferencesInFacilityPage = 'mpShipperPreferencesInFacilityPage',
  shipperAppGraphqlLanesPage = 'shipperAppGraphqlLanesPage',
  mpAppointmentAutomations = 'mpAppointmentAutomations',
  mpNewPodNames = 'mpNewPodNames',
  mpEditAppointmentAutomations = 'mpEditAppointmentAutomations',
}

export type featureFlagKeys = keyof typeof FEATURE_FLAGS

export interface IApiFeatureFlag {
  key: featureFlagKeys
  enabled: boolean
}

/**
 * Outline which layer set the flag to the given value
 * 'default' < 'api' < 'qs' < 'setting'
 */
export type sourceType = 'default' | 'api' | 'qs' | 'setting'

export interface IFeatureFlagValue {
  enabled: boolean
  source: sourceType
}

type FeatureFlags = {
  [key in featureFlagKeys]: IFeatureFlagValue
}

interface IUseFeatureFlags {
  readonly flags: FeatureFlags
  getFlag: (key: featureFlagKeys) => IFeatureFlagValue
  setFlag: (key: featureFlagKeys, value: boolean, source: sourceType) => void
  error?: string
  hasLoaded: boolean
}

export const FEATURES_DEFAULTS: FeatureFlags = {
  fmsUpdatedAmPodOptions: {
    enabled: false,
    source: 'default',
  },
  fmsUpdatedBrokerPodOptions: {
    enabled: false,
    source: 'default',
  },
  enableTruckerToolsLoadBoardPostStatusInMP: {
    enabled: false,
    source: 'default',
  },
  mpQrConfirmationModal: {
    enabled: false,
    source: 'default',
  },
  fmsFrontChat: {
    enabled: false,
    source: 'default',
  },
  fmsPrebookingLoadDetailsMap: {
    enabled: false,
    source: 'default',
  },
  fmsSkipW9: {
    enabled: false,
    source: 'default',
  },
  fmsSubmitSafetyLetter: {
    enabled: false,
    source: 'default',
  },
  enableEinRule: {
    enabled: false,
    source: 'default',
  },
  enableCarrierHomepageForAll: {
    enabled: false,
    source: 'default',
  },
  amazonConnectClickToCall: {
    enabled: false,
    source: 'default',
  },
  enableFraudValidation: {
    enabled: false,
    source: 'default',
  },
  enableNewCarrierAppHomepage: {
    enabled: false,
    source: 'default',
  },
  fmsOnboardingForm: {
    enabled: false,
    source: 'default',
  },
  mpNavigationBarUpdate: {
    enabled: false,
    source: 'default',
  },
  lockStormDashboardFrontend: {
    enabled: false,
    source: 'default',
  },
  highwayCarrierApplicationFlow: {
    enabled: false,
    source: 'default',
  },
  enableCarrierCompIncentive: {
    enabled: false,
    source: 'default',
  },
  enableCarrierOptionPageSize: {
    enabled: false,
    source: 'default',
  },
  autobiddersConfigurationPage: {
    enabled: false,
    source: 'default',
  },
  motorCarrierProfileShowDiverseCarrierCertificationsCard: {
    enabled: false,
    source: 'default',
  },
  highRiskLoadsFlag: {
    enabled: false,
    source: 'default',
  },
  enableFmsGraphqlRecs: {
    enabled: false,
    source: 'default',
  },
  fmsOnboardingCarrierMutation: {
    enabled: false,
    source: 'default',
  },
  motorCarrierProfileShowLoadPreferencesCard: {
    enabled: false,
    source: 'default',
  },
  motorCarrierProfileHideFmsNav: {
    enabled: false,
    source: 'default',
  },
  motorCarrierProfileShowFmsTag: {
    enabled: false,
    source: 'default',
  },
  motorCarrierProfileShowSmartWayCarrierCard: {
    enabled: false,
    source: 'default',
  },
  motorCarrierProfileShowSavedLanesCard: {
    enabled: false,
    source: 'default',
  },
  mpMarketInsights: {
    enabled: false,
    source: 'default',
  },
  disableStarkShipmentCreate: {
    enabled: false,
    source: 'default',
  },
  mpRelayAccessorials: {
    enabled: false,
    source: 'default',
  },
  enableRogersShipmentCloning: {
    enabled: false,
    source: 'default',
  },
  newShipperTransfixTeamForm: {
    enabled: false,
    source: 'default',
  },
  mpTrueRatePlus: {
    enabled: false,
    source: 'default',
  },
  movePodWarningToTopInCarrierApp: {
    enabled: false,
    source: 'default',
  },
  mpShipperPage: {
    enabled: false,
    source: 'default',
  },
  enableRogersShipmentCreateForm: {
    enabled: false,
    source: 'default',
  },
  enableAwardedLaneListingDetails: {
    enabled: false,
    source: 'default',
  },
  enableRogersCarrierForm: {
    enabled: false,
    source: 'default',
  },
  removeSchedulingTab: {
    enabled: false,
    source: 'default',
  },
  /**
   * In the Awarded Lanes page, allow Lane Agreement documents to be attached to Sourced Carrier Rates.
   * @see https://transfix.atlassian.net/browse/PPCU-814
   */
  laneAgreements: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables new map for driver locations
   * @see https://transfix.atlassian.net/browse/FEP-725
   */
  tmsDriverMap: {
    enabled: false,
    source: 'default',
  },
  separateCoverageRoute: {
    enabled: false,
    source: 'default',
  },
  reOfferShipment: {
    enabled: false,
    source: 'default',
  },
  shipmentTonu: {
    enabled: false,
    source: 'default',
  },
  testFlag: {
    enabled: false,
    source: 'default',
  },
  trackingSegment: {
    enabled: false,
    source: 'default',
  },
  loadComments: {
    enabled: false,
    source: 'default',
  },
  loadsListFunctionalStatusTag: {
    enabled: false,
    source: 'default',
  },
  highwayMilestoneFourComplianceTab: {
    enabled: false,
    source: 'default',
  },
  usePcMilerLocation: {
    enabled: false,
    source: 'default',
  },
  stagingRulesDebugger: {
    enabled: false,
    source: 'default',
  },
  highwayMilestoneThreeInsuranceCard: {
    enabled: false,
    source: 'default',
  },
  loadDetailsActivity: {
    enabled: false,
    source: 'default',
  },
  newShipmentDetailsPageUrls: {
    enabled: false,
    source: 'default',
  },
  shipmentDispatch: {
    enabled: false,
    source: 'default',
  },
  shipmentDetailsTenderLive: {
    enabled: false,
    source: 'default',
  },
  marketplaceUserTrackingTab: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables editing for Additional Carrier Info
   * @see https://transfix.atlassian.net/browse/TT-99
   */
  editAdditionalCarrierInfo: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables syncing highway data on carrier profile
   */
  carrierAppHighwayButtonSync: {
    enabled: false,
    source: 'default',
  },
  carrierAppW9RestrictUpload: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables the Quickbooks Integration route in Fleet Planner's settings
   * @see https://transfix.atlassian.net/browse/FP-1723
   */
  fpQuickbooksIntegration: {
    enabled: true,
    source: 'default',
  },
  fpAddReloads: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables the Carrier Portal <> FP updating loads settings
   * @see https://transfix.atlassian.net/browse/FP-1799
   */
  fpCarrierPortal: {
    enabled: false,
    source: 'default',
  },
  fmsPaymentStatus: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables Confettis
   */
  confettis: {
    enabled: false,
    source: 'default',
  },
  dropTrailerNumber: {
    enabled: false,
    source: 'default',
  },
  /**
   * Increase the upload limit on BCA documents from 3 to 7
   */
  fmsBcaIncreaseUploadLimit: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables showing driver's sms opt in on FMS team members page & mobile single team member view
   */
  fmsTeamMembersShowDriverSmsOptInStatus: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables the new BtfModal flow
   * @see https://transfix.atlassian.net/browse/PMNTS-1205
   */
  shipperBTFFlexibleRules: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables new FMS onboarding experience and setup guide
   */
  fmsOnboarding: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables new FMS offers dashboard and page
   */
  fmsOffersPage: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables new FMS offer expiration functionality/view
   * NOTE: FMS Decline was separated from this FF
   */
  fmsOffersPageExpiredAndDeclined: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables workflow for deleting transfix account
   */
  fmsAccountDeletion: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables new FMS book loads mobile optimizations
   */
  fmsBookLoadsMobile: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables new FMS book loads optimizations
   */
  fmsBookLoadsOptLanes: {
    enabled: false,
    source: 'default',
  },
  /**
   * Displays Load Details, Facility Details, and Additional Notes sections in the Dedicated Lane page.
   */
  fmsDedicatedLaneListingDetails: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables new FMS saved shipment search
   */
  fmsSavedShipmentSearch: {
    enabled: false,
    source: 'default',
  },
  /**
   * Displays the max age filter on FMS' my loads page
   */
  fmsShipmentMaxAgeFilter: {
    enabled: true,
    source: 'default',
  },
  /**
   * Enables new FMS CM created saved shipment search
   */
  fmsCmSavedShipmentSearch: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables new FMS automated saved shipment search
   */
  fmsLaneRecommendations: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables new FMS share trucks feature
   */
  fmsShareAvailableTrucks: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables new FMS automated status updates features
   */
  fmsAutomatedStatusUpdates: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables new side nav experience in FMS
   */
  fmsSideNav: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables RFP Lane Match Downloads.
   */
  rfpLaneMatchDownload: {
    enabled: false,
    source: 'default',
  },
  /**
   * Displays "Enable Live Tracking" button in FMS Load Assignment form
   * @see https://transfix.atlassian.net/browse/FP-2089
   */
  fmsEnableTrackingButton: {
    enabled: false,
    source: 'default',
  },
  /**
   * Displays tracking ELD for Marketplace loads on Load Details
   * FP-2652 Epic
   */
  fmsELDTracking: {
    enabled: false,
    source: 'default',
  },
  /**
   * FMS Fleet Mobile View optimizations
   * https://transfix.atlassian.net/browse/FP-1034
   */
  fmsFleetMobileView: {
    enabled: false,
    source: 'default',
  },
  // Enables the updated carrier states
  useNewStateTagsMp: {
    enabled: false,
    source: 'default',
  },
  /**
   * Displays latest carrier option filters
   */
  isNewCarrierOptionFilterEnable: {
    enabled: true,
    source: 'default',
  },
  /**
   * In the new Carrier Profile show the new FMS based Lane Alerts
   */
  newLaneAlerts: {
    enabled: false,
    source: 'default',
  },
  /**
   * New Dedicated Lanes Page https://transfix.atlassian.net/browse/FP-3200
   */
  dedicatedLanesPage: {
    enabled: false,
    source: 'default',
  },
  /**
   * New Dedicated Lanes Page https://transfix.atlassian.net/browse/FP-3200
   */
  dedicatedLanesPageCapacity: {
    enabled: false,
    source: 'default',
  },
  dedicatedLanesPageSms: {
    enabled: false,
    source: 'default',
  },
  /**
   * In the new Carrier Profile show the new Routing Guides card
   * https://transfix.atlassian.net/browse/PPCU-46
   */
  newRoutingGuides: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enable driver two flow in load share on FMS
   * https://transfix.atlassian.net/browse/CE-542
   */
  fmsDriverTwoLoadShare: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enable driver two flow in load share on FMS
   * https://transfix.atlassian.net/browse/CE-542
   */
  fmsDriver2LoadShare: {
    enabled: false,
    source: 'default',
  },
  /**
   * When enabled, users can open a modal to submit a norm file for refresh (instant rfp)
   */
  refreshNormFile: {
    enabled: false,
    source: 'qs',
  },
  mpNotificationsCenter: {
    enabled: false,
    source: 'default',
  },
  /**
   * Feature flag for showing shipper fuel schedules tab in shipper profile page.
   */
  mpShipperFuelSchedule: {
    enabled: false,
    source: 'default',
  },
  /**
   * Feature flag for accept/reject automation tab in shipper profile page.
   */
  mpAcceptRejectAutomation: {
    enabled: false,
    source: 'default',
  },
  /**
   * Feature flag for allowing users to configure accept/reject automation.
   */
  mpAcceptRejectConfiguration: {
    enabled: false,
    source: 'default',
  },
  /**
   * Feature flag for repricing changes to the shipper rates page.
   */
  mpRmsRepricedRates: {
    enabled: true,
    source: 'default',
  },
  /**
   * Feature flag for repricing changes to the shipper rates page.
   */
  mpRmsTrueRates: {
    enabled: false,
    source: 'default',
  },
  /**
   * Used to redirect to new shipment details page after issue creation for testing
   */
  redirectToNewShipmentDetails: {
    enabled: false,
    source: 'default',
  },
  /**
   * Used to display Strategic Buy Rate.
   */
  displayStrategicBuyRate: {
    enabled: false,
    source: 'default',
  },
  /**
   * Displays the general information card in shipment-details page
   */
  displayGeneralCardReport: {
    enabled: false,
    source: 'default',
  },
  // FMS tracking conversion feature
  fmsTrackingConversion: {
    enabled: false,
    source: 'default',
  },
  // FMS redirect users admin approval feature
  fmsRedirectUsersAdminApproval: {
    enabled: false,
    source: 'default',
  },
  /**
   * Display new FMS reloads post rate con modal
   */
  fmsReloadsModal: {
    enabled: false,
    source: 'default',
  },
  /**
   * Display cover button in shipment details page
   */
  shipmentCover: {
    enabled: false,
    source: 'default',
  },
  /**
   * Display cancel button in shipment details page
   */
  shipmentDetailsCancel: {
    enabled: false,
    source: 'default',
  },
  /**
   * Display Accept/Reject button in shipment details page
   */
  shipmentDetailsAcceptReject: {
    enabled: false,
    source: 'default',
  },
  /**
   * Display Driver SMS in shipment details apge
   */
  shipmentDetailsSMS: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables the new Marketplace Authentication Provider
   */
  mpAuthenticationProvider: {
    enabled: false,
    source: 'default',
  },
  /**
   * Display the view of Document Card in shipment-details page
   */
  shipmentDocumentsCard: {
    enabled: false,
    source: 'default',
  },
  /**
   * Display the Acesorials in the new shipment detail
   */
  shipmentAccesorials: {
    enabled: false,
    source: 'default',
  },
  /**
   * Show scheduling tab in shipment detail page
   */
  fmsStatusUpdateToggle: {
    enabled: false,
    source: 'default',
  },
  schedulingTab: {
    enabled: false,
    source: 'default',
  },
  /**
   * Allow editing in appointment view
   */
  editingAppointment: {
    enabled: false,
    source: 'default',
  },
  /**
   * Show FMS Driver SMS
   */
  viewFmsSms: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables the shipment options in new shipment detail page
   */
  shipmentDetailsOptions: {
    enabled: false,
    source: 'default',
  },
  /**
   * Show Looker logs in shipment details page
   */
  showLookerShipmentLogs: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables displaying Tender Tracking Info on the shipment side panel
   */
  shipmentSidePanelTenderTrackingInfo: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables new Rogers Auth Pages
   */
  rogersAuthPages: {
    enabled: false,
    source: 'default',
  },
  /**
   * When enabled, TMS users see the new home page
   */
  tmsNewHomePage: {
    enabled: false,
    source: 'default',
  },
  /**
   * When enabled, SHIP users see the new home page modal
   */
  tmsNewHomePageModal: {
    enabled: false,
    source: 'default',
  },
  /**
   * When enabled food grade equipment related features will be shown
   */
  tmsFoodGrade: {
    enabled: false,
    source: 'default',
  },
  /**
   * When enabled bulk shipment page can be accessed
   */
  tmsBulkUpload: {
    enabled: false,
    source: 'default',
  },
  /**
   * When enabled bulk questions for shipper will be shown.
   */
  tmsRSOShipperCompliance: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables editing in shipment general accounting card
   */
  shipmentGeneralAccountingCardEdit: {
    enabled: false,
    source: 'default',
  },
  /**
   * Displays the Matching Shipments tab in carrier-details page
   */
  displayMatchingShipmentsCard: {
    enabled: false,
    source: 'default',
  },
  /**
   * Allow user to edit accesorials in the new shipment details page
   */
  editShipmentAccessorials: {
    enabled: false,
    source: 'default',
  },
  /**
   * TMS - Allow location autocomplete component usages to retrieve CA and MX addresses too.
   */
  tmsSupportCAMXAddresses: {
    enabled: false,
    source: 'default',
  },
  /**
   * Shipment Details - show invoices in document card
   */
  invoicesDocuments: {
    enabled: false,
    source: 'default',
  },
  /**
   * Shipment Details - show pod in document card
   */
  podDocuments: {
    enabled: false,
    source: 'default',
  },
  /**
   * Shipment Details - Routing Guide
   */
  shipmentDetailsRoutingGuide: {
    enabled: false,
    source: 'default',
  },
  /**
   * Shipment Details - Pending Appointments Modal
   */
  shipmentDetailsPendingAppointments: {
    enabled: false,
    source: 'default',
  },
  /**
   * Shipment Details - Vertical Progress List for Check In/Out
   */
  shipmentDetailsEditVerticalProgressList: {
    enabled: false,
    source: 'default',
  },
  /**
   * Shipment Details - Clone Shipment
   * @see https://transfix.atlassian.net/browse/SDR-636
   */
  cloneShipmentButton: {
    enabled: false,
    source: 'default',
  },
  /**
   * Hiding Pickup/Delivery Instructions in load details
   */
  fmsLoadDetailsInformation: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables the new setup guide in TMS
   */
  tmsSetupGuide: {
    enabled: false,
    source: 'default',
  },

  /**
   * Enables onboarding flow
   */
  tmsOnboarding: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables automated credit check modal
   */
  tmsCreditCheck: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables the new Insights page including CTA in the left menu
   */
  tmsInsightsPage: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables the new Insights page - Data Download section
   */
  tmsInsightsDataDownload: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables the new Insights page - Facilities section
   */
  tmsInsightsFacilities: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables the new Insights page - Overview section
   */
  tmsInsightsOverview: {
    enabled: false,
    source: 'default',
  },
  /**
   * Hiding Detention Request link in load details
   */
  fmsDetentionRequest: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables new fields for tracking details Trailer Number and Driver Name
   */
  tmsTrailerNumberDriverName: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables mileage copy for shipment creation for ltl and intermodal
   */
  tmsMileage: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables uploading multiple POD files
   */
  tmsMultiPODs: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables coordinator a.k.a. Assigned to for shipment creation and list.
   */
  tmsAssignedTo: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables draft state shipment notes
   */
  tmsDraftShipmentNotes: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables bumblebee to tag transfix on messages.
   */
  tmsTransfixTagNote: {
    enabled: false,
    source: 'default',
  },
  /**
   * Shipment Details - show invoice attachments in document card
   */
  invoiceAttachmentDocuments: {
    enabled: false,
    source: 'default',
  },
  /**
   * Shipmenty Details - show scale tickets in document card
   */
  scaleTicketDocuments: {
    enabled: false,
    source: 'default',
  },
  /**
   * Combines pod files into a single PDF file when more than one are uploaded
   */
  fmsCombinePodFiles: {
    enabled: false,
    source: 'default',
  },
  /**
   * Shipmenty Details - show miscellanous in document card
   */
  miscDocuments: {
    enabled: false,
    source: 'default',
  },
  /**
   * Adds rearrange stop feature to shipment details
   * @see https://transfix.atlassian.net/browse/SDR-626
   */
  rearrangeStopsButton: {
    enabled: false,
    source: 'default',
  },
  /**
   * enables graphql W9 upload in carrier app
   */
  carrierAppNewW9Upload: {
    enabled: false,
    source: 'default',
  },
  /**
   * enables milestone 5 graphql upload in carrier app
   */
  carrierAppMilestoneFiveCarrierUpload: {
    enabled: false,
    source: 'default',
  },
  /**
   * Displays a delete shipment button in rearrange stops modal
   * @see https://transfix.atlassian.net/browse/SDR-625
   */
  deleteShipmentStops: {
    enabled: false,
    source: 'default',
  },
  /*
    Once we are ready to add a manual quote type checkbox feature to the AM quoting tool,
    this will be enabled. Currently it is disabled to hide developed features
  */
  amQuotingManualQuoteType: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables Add Shipment Stop Modal
   * @see https://transfix.atlassian.net/browse/SDR-755
   */
  addStopButton: {
    enabled: false,
    source: 'default',
  },
  /**
   * Show "Delete Bid" button on BidModal in FMS
   */
  fmsDeleteBid: {
    enabled: true,
    source: 'default',
  },
  /**
   * Enables POD approval flow button
   * @see https://transfix.atlassian.net/browse/SDR-648
   */
  podApprovalButton: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables new carrier scorecard
   * @see https://transfix.atlassian.net/browse/SDR-648
   */
  extendedScorecard: {
    enabled: false,
    source: 'default',
  },
  /** Enables uncancel button in shipment details header
   * @see https://transfix.atlassian.net/browse/SDR-447
   */
  uncancelShipment: {
    enabled: true,
    source: 'default',
  },
  /** Enables uncancel button in shipment details header
   * @see https://transfix.atlassian.net/browse/SO-3415
   */
  newFacilityPageLink: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables dedicated lanes contact us modal
   * @see https://transfix.atlassian.net/browse/FP-3694
   */
  dedicatedLanesContactModal: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables dedicated lanes expiring soon tag
   * @see https://transfix.atlassian.net/browse/FP-3697
   */
  dedicatedLanesExpiringSoonTag: {
    enabled: false,
    source: 'default',
  },
  /**
   * Calls and displays guided bid messages
   * @see https://transfix.atlassian.net/browse/FP-3510
   */
  fmsGuidedBidding: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables home page enhancements
   * @see https://transfix.atlassian.net/browse/FP-3741
   * @see https://transfix.atlassian.net/browse/FP-3742
   * @see https://transfix.atlassian.net/browse/FP-3743
   */
  homePageUpdates: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables batching of GraphQL operations into a single request
   */
  graphqlBatching: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables use of ray tracer to fetch gamma ray versions / logs
   */
  useRayTracer: {
    enabled: false,
    source: 'default',
  },
  /**
   * When enabled, shows the shipment logs loading link on the shipment details page logs tab
   */
  showStarkShipmentLogsLink: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables request compliance approval button in shipment details coverage tab.
   */
  requestComplianceApproval: {
    enabled: false,
    source: 'default',
  },
  /**
   * Show counter bids on pending FMS bids
   * @see https://transfix.atlassian.net/browse/FP-3234
   */
  fmsCounterBidding: {
    enabled: false,
    source: 'default',
  },
  /**
   * Adds option to adjust past pickup date
   */
  faPastPickupDateAdjustment: {
    enabled: false,
    source: 'default',
  },
  /**
   * Intermodal Shipments
   */
  tmsIntermodal: {
    enabled: false,
    source: 'default',
  },
  /**
   * BumbleBee Daily Digest
   */
  bumbleBeeDDigest: {
    enabled: false,
    source: 'default',
  },
  /**
   * QBR / Reports in TMS
   */
  tmsShipperReports: {
    enabled: false,
    source: 'default',
  },
  /**
   * Add in more approvals and audit steps for claims loads in order to be billed/invoiced
   */
  showClaimsAllowBillingInvoicing: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables Market Insights - "First Come First Serve" Label
   */
  fmsMarketInsightsFcfsLabel: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables Translating SMS Messages in Shipment Details
   */
  smsTranslate: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables the Stark UI updates for SMS
   */
  smsStarkUiChanges: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables the new map component
   */
  mapAndPingsTab: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables Shipment offer declination via FMS
   * NOTE: this was separated from expired bids
   */
  fmsDeclineBid: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables using the new map component
   * on the detention review page
   */
  detentionNewMap: {
    enabled: false,
    source: 'default',
  },
  detentionPageAddToggle: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables FMS new onboarding process
   *
   */
  fmsHighwayCarrierOnboarding: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables new Setup Guide FMS state checks for Highway MVP
   *
   */
  fmsHighwayMilestoneFour: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables edit status on Carrier Status
   *
   */
  highwayMilestoneTwoCarrierStatusEditStatus: {
    enabled: false,
    source: 'default',
  },
  detentionPageShowIssues: {
    enabled: false,
    source: 'default',
  },
  detentionPageShowAccessorialPolicy: {
    enabled: true,
    source: 'default',
  },
  /**
   * Enables Market Insights - Popular shipments label
   */
  fmsMarketInsightsPopularShipmentsLabel: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables Market Insights - Great Rate label
   */
  fmsMarketInsightsGreatRateLabel: {
    enabled: false,
    source: 'default',
  },
  /**
   * Enables the display of SPF Shipment Tracking Info on the shipper details page
   */
  shipperDetailsSpf: {
    enabled: false,
    source: 'default',
  },
  /** Enables Remove Tonu Functionality via Remove Tonu Button */
  removeTonuServiceable: {
    enabled: false,
    source: 'default',
  },
  removeTonuFromInvoiceSent: {
    enabled: false,
    source: 'default',
  },
  unDeliverShipmentsButtonNewConditions: {
    enabled: false,
    source: 'default',
  },
  canEditApprovedDetention: {
    enabled: false,
    source: 'default',
  },
  /** Enables Saving multiple searches in Issue Page List */
  mpIssuePageListSaveSearches: {
    enabled: false,
    source: 'default',
  },
  editingInOutTimesPostDelivered: {
    enabled: false,
    source: 'default',
  },
  /** Enables TMS Cost+ related work */
  tmsCostPlus: {
    enabled: false,
    source: 'default',
  },
  /** Enables Carrier Scorecard Page */
  carrierScorecardPage: {
    enabled: false,
    source: 'default',
  },
  /** Enables Equipment Listing Page */
  fmsEquipmentListingPage: {
    enabled: false,
    source: 'default',
  },
  /** Enables showing the trailer row in the stop dropdowns on shipment details */
  stopTrailerRow: {
    enabled: false,
    source: 'default',
  },
  /** Enables shiper's internal notes on TMS shipments */
  tmsShipmentNotes: {
    enabled: false,
    source: 'default',
  },
  /** Uses trailer dropdown on ratecon in lieu of freeform text field */
  fpTrailerOnRateConPage: {
    enabled: false,
    source: 'default',
  },
  /** Enables issues SLAs and escalation related work */
  issueSLAsAndEscalation: {
    enabled: false,
    source: 'default',
  },
  /** Displays strategy information within the cost in stark dashboard * */
  costInStarkDashboardStrategyInformation: {
    enabled: false,
    source: 'default',
  },
  /** Enables RFP lanes data import/export */
  rfpLanesImportExportEnabled: {
    enabled: false,
    source: 'default',
  },
  /** Enables pricing strategy management in Stark * */
  stormStrategyManagement: {
    enabled: false,
    source: 'default',
  },
  /** Enables error handling features in the Storm RFP dashboard. */
  mpStormErrorHandling: {
    enabled: false,
    source: 'default',
  },
  /** Enables award management in Stark * */
  stormAwardManagement: {
    enabled: false,
    source: 'default',
  },
  /** Enables refreshing individual lanes in Storm. */
  mpStormLaneRefresh: {
    enabled: false,
    source: 'default',
  },
  /** Hides carrier manager target rates from non-priveleged users */
  maskCmtRates: {
    enabled: false,
    source: 'default',
  },
  /** Feature Flag for drop trailer timestamps */
  dropTrailerTimestamps: {
    enabled: false,
    source: 'default',
  },
  /** Enables out of office management tool */
  enableOooManagement: {
    enabled: false,
    source: 'default',
  },
  /** Enables drop trailer feature in Marketplace */
  mpDropTrailer: {
    enabled: false,
    source: 'default',
  },
  /** Enables form modal for adding facility in lieu of stark page */
  enableNewAddFacilityModal: {
    enabled: false,
    source: 'default',
  },
  /** Enables editing certain shipment details stop timestamps before dispatched */
  allowEarlyTimestampEditing: {
    enabled: false,
    source: 'default',
  },
  /** Allows drivers to submit a one-time location through driver-led status */
  driverLedLocation: {
    enabled: false,
    source: 'default',
  },
  /** Submits dedicated lanes bids using the v2 snowflake schema */
  dedicatedLanesBidEventV2: {
    enabled: false,
    source: 'default',
  },
  /**  */
  /** Enable drop trailer pool */
  dropTrailerPool: {
    enabled: false,
    source: 'default',
  },
  /** Enables the Trailers tab on the carrier profile page */
  carrierTrailerManagement: {
    enabled: false,
    source: 'default',
  },
  /** Enables shipper rate sourcing information display */
  shipperRateSourcing: {
    enabled: false,
    source: 'default',
  },
  /** Displays the add multi stop option on AM quoting tool */
  multiStopQuotingAmqt: {
    enabled: false,
    source: 'default',
  },
  /** Displays the add multi stop option on AM quoting tool */
  moveMapAndPings: {
    enabled: false,
    source: 'default',
  },
  /** Enables availability toggles within CM groups */
  loadAssignmentAvailability: {
    enabled: false,
    source: 'default',
  },
  /** Enables the new Spot quote tool */
  spotQuoteTool: {
    enabled: false,
    source: 'default',
  },
  /** Enables the saved lanes general information card on marketplace's carrier page */
  enableSavedLanesMP: {
    enabled: false,
    source: 'default',
  },
  /** Enables connect fuel to shipments in MP */
  mpConnectFuelToShipments: {
    enabled: false,
    source: 'default',
  },
  /** Enables step pricing rules in the Strike Price Control Panel * */
  spcpStepPricing: {
    enabled: false,
    source: 'default',
  },
  /** Displays fuel surcharge card in sqt */
  sqtFuelSurcharge: {
    enabled: false,
    source: 'default',
  },
  /** Displays SQT applied rules data */
  sqtAppliedRulesData: {
    enabled: false,
    source: 'default',
  },
  /** Enables POD Rejection Reason */
  fmsRejectionReasonPOD: {
    enabled: false,
    source: 'default',
  },
  /** Displays target dedicated details and filter on the shipments page */
  fmsTargetDedicatedShipments: {
    enabled: false,
    source: 'default',
  },
  /** Displays who else is here on the shipments page */
  whoElseIsHere: {
    enabled: false,
    source: 'default',
  },
  /** Enables new FMS One Time SMS Load Sharing */
  fmsOneTimeSmsLoadShare: {
    enabled: false,
    source: 'default',
  },
  /** Enables booking experience with true rate plus in shipper app */
  shipperAppTrueRateBookingExperience: {
    enabled: false,
    source: 'default',
  },
  /** Enables reporting enhancements for true rate plus in shipper app */
  shipperAppTrueRateReporting: {
    enabled: false,
    source: 'default',
  },
  /** Enables true rate enhancements in the shipment details in shipper app */
  shipperAppTrueRateShipmentDetails: {
    enabled: false,
    source: 'default',
  },
  checkIsUserValidationChecked: {
    enabled: false,
    source: 'default',
  },
  /** Show Rep Groups options in groups page */
  mpRepGroups: {
    enabled: false,
    source: 'default',
  },
  newCarrierProfileSidebar: {
    enabled: false,
    source: 'default',
  },
  /** Enables RFP Creation flow in Shipper App */
  shipperAppRFPCreation: {
    enabled: false,
    source: 'default',
  },
  /** Enables RFP Objective 4 in Shipper App */
  shipperAppRFPO4: {
    enabled: false,
    source: 'default',
  },
  /** Enables RFP Objective 5 in Shipper App */
  shipperAppRFPO5: {
    enabled: false,
    source: 'default',
  },
  /** Enables adding and removing Related Shipments  */
  mpRelatedShipments: {
    enabled: false,
    source: 'default',
  },
  displayFacilityName: {
    enabled: false,
    source: 'default',
  },
  hideFacilityAddress: {
    enabled: false,
    source: 'default',
  },
  /** Displays GraphQL pages in Shipper App */
  shipperAppGraphQL: {
    enabled: false,
    source: 'default',
  },
  /** Enables managing, and using the broker-pods grouping for assigning ops-rep */
  useBrokerPods: {
    enabled: false,
    source: 'default',
  },
  /** Updating Saved Lanes Create/Update to have unique records per carrier */
  refactoredSavedLanesCreateAndUpdate: {
    enabled: false,
    source: 'default',
  },
  /** Enables assigning contacts to vendors */
  mpFacilityVendorContacts: {
    enabled: false,
    source: 'default',
  },
  /** Enables new motor carrier state display labels */
  useNewCarrierStatusTags: {
    enabled: false,
    source: 'default',
  },
  /** Enables vendor list */
  mpFacilityPagination: {
    enabled: false,
    source: 'default',
  },
  mpVendorList: {
    enabled: false,
    source: 'default',
  },
  /** Eliminate duplicate facilities on create */
  mpEliminateDuplicates: {
    enabled: false,
    source: 'default',
  },
  /** Show Smart Appointments and Quick request icons in Shipment Detail Page */
  mpEmailSchedulingVisibility: {
    enabled: false,
    source: 'default',
  },
  /** Ability to snooze a task in TAM */
  mpTaskSnoozing: {
    enabled: false,
    source: 'default',
  },
  /** Turn on the new scheduler page */
  mpNewSchedulerPage: {
    enabled: false,
    source: 'default',
  },
  /** Turn on SOP Links card on shipper page */
  mpSOPLinks: {
    enabled: false,
    source: 'default',
  },
  /** Turn on Shipment Issue Automation page */
  mpShipmentIssueAutomation: {
    enabled: false,
    source: 'default',
  },
  /** Turn on Shipment Issue Automation page Milestone 2 */
  mpShipmentIssueAutomationM2: {
    enabled: false,
    source: 'default',
  },
  /** Turn on Shipment Issue Automation page Milestone 4 */
  mpShipmentIssueAutomationM4: {
    enabled: false,
    source: 'default',
  },
  /** Turn on Shipment Issue Automation page Milestone 4 */
  mpShipmentIssueAutomationM5: {
    enabled: false,
    source: 'default',
  },
  /** Display storm dashboard url instead of google sheets if pricing workspace exists */
  stormUrlAwardedLanes: {
    enabled: false,
    source: 'default',
  },
  /** Show tracking status / warnings based on whether the global definition of tracking is live */
  useGlobalDefinitionOfTracking: {
    enabled: false,
    source: 'default',
  },
  /** Display the rfp award status tag on insta rfp page */
  displayRfpStatusTag: {
    enabled: false,
    source: 'default',
  },
  /** Display Archived Certs Tab in Insurance Card on Carrier Compliance Page */
  highwayArchivedCerts: {
    enabled: false,
    source: 'default',
  },
  /** Update Marketplace carrier Data with highway data */
  syncHighwayWithMarketplace: {
    enabled: false,
    source: 'default',
  },
  /** Hide Delete BCA Button on Carrier Compliance Page */
  hideDeleteBcaButton: {
    enabled: false,
    source: 'default',
  },
  /** Display Deprecated BCAs in Documents Card on Carrier Compliance Page */
  showDeprecatedBcas: {
    enabled: false,
    source: 'default',
  },
  /** Auto-Create Issue When Shipment Accessorial is OOP */
  oopAutoIssueCreate: {
    enabled: true,
    source: 'default',
  },
  /** Will show the controls to merge multiple facilities at the same time */
  mpMergeBulkFacilities: {
    enabled: false,
    source: 'default',
  },
  sqtObjectiveFour: {
    enabled: false,
    source: 'default',
  },
  mpStepsToResolve: {
    enabled: false,
    source: 'default',
  },
  /** Show suggested times feature in rogers */
  suggested_appointments_persist_to_appointment: {
    enabled: false,
    source: 'default',
  },
  allowNewMyLoadsTable: {
    enabled: false,
    source: 'default',
  },
  mpArchiveVendors: {
    enabled: false,
    source: 'default',
  },
  carrierPortalMaintenance: {
    enabled: false,
    source: 'default',
  },
  /** Display the QR code confirmation modal when changing drivers */
  fpQrConfirmationModal: {
    enabled: false,
    source: 'default',
  },
  /** Enables new carrier accessorial approval flow (with manual CM approval) */
  carrier_accessorial_approval_flow: {
    enabled: false,
    source: 'default',
  },
  /** Give the users the ability to change the rolled status of a shipment */
  mpRolledShipmentStatus: {
    enabled: false,
    source: 'default',
  },
  /** Enables ability to manually close RFP Bidding Window */
  shipperAppManualCloseBid: {
    enabled: false,
    source: 'default',
  },
  /** Show shipper preferences in facility page */
  mpShipperPreferencesInFacilityPage: {
    enabled: false,
    source: 'default',
  },
  /** enables shipper app graphql lanes page at tms/lanes */
  shipperAppGraphqlLanesPage: {
    enabled: false,
    source: 'default',
  },
  /** Show appoinment automations in shipper page > operations tab */
  mpAppointmentAutomations: {
    enabled: false,
    source: 'default',
  },
  /** Show pods name by color instead of numbers in booking and TAM page */
  mpNewPodNames: {
    enabled: false,
    source: 'default',
  },
  /** Show button to edit appoinment automations in shipper page > operations tab */
  mpEditAppointmentAutomations: {
    enabled: false,
    source: 'default',
  },
}

const useFeatureFlags = (): IUseFeatureFlags => {
  const [flags, _setFlags] = useState<FeatureFlags>(FEATURES_DEFAULTS)
  const [error, setError] = useState<string>()
  const [hasLoaded, setHasLoaded] = useState<boolean>(false)
  const { search } = useLocation()

  const setFlag = (key: featureFlagKeys, value: boolean, source: sourceType) =>
    _setFlags({
      ...flags,
      [key]: { enabled: value, source },
    })

  useEffect(() => {
    const fetchFlags = async () => {
      setError(undefined)
      try {
        const { flags: apiFlags }: { flags: IApiFeatureFlag[] } = await callApi({
          endpoint: ENDPOINTS.featureFlags,
        })
        const newApiFlags = apiFlags.reduce(
          (acc, f) => ({
            ...acc,
            [f.key]: { enabled: f.enabled, source: 'api' },
          }),
          {} as FeatureFlags
        )

        // Query Param Overrides
        const QSFlags = queryString.parse(search)
        const newQSFlags = mapValues(QSFlags, f => ({ enabled: f !== 'false', source: 'qs' }))

        _setFlags({
          ...flags,
          ...newApiFlags,
          ...newQSFlags,
        })

        setHasLoaded(true)
      } catch (e) {
        setError(e)
      }
    }

    if (!hasLoaded) {
      fetchFlags()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search])

  const getFlag = (key: featureFlagKeys): IFeatureFlagValue => flags[key]

  return { flags, hasLoaded, error, setFlag, getFlag }
}

export interface IFeatureFlagsState extends IUseFeatureFlags {
  errors?: string
}

/**
 * Init the context
 */
const featureFlagsDefaultState: IFeatureFlagsState = {
  flags: FEATURES_DEFAULTS,
  hasLoaded: false,
  error: undefined,
  getFlag: () => FEATURES_DEFAULTS.testFlag,
  setFlag: () => undefined,
}

export const FeatureFlagsContext = createContext<IFeatureFlagsState>(featureFlagsDefaultState)

/**
 * Provide default Provider state component to wrap around app
 */
export function FeatureFlagsProvider({ children }: { children: ReactNode }): JSX.Element {
  const { error, flags, getFlag, hasLoaded, setFlag: setFeatureFlag } = useFeatureFlags()

  // Set a given flag to a given value
  const setFlag = useCallback(
    (key: keyof typeof FEATURES_DEFAULTS, value: boolean) => setFeatureFlag(key, value, 'setting'),
    [setFeatureFlag]
  )

  const featureFlagsState = {
    flags,
    hasLoaded,
    error,
    setFlag,
    getFlag,
  }

  return (
    <FeatureFlagsContext.Provider value={featureFlagsState}>
      {children}
    </FeatureFlagsContext.Provider>
  )
}

export const useFeatureFlagContext = () => useContext(FeatureFlagsContext)

/**
 * Easy way to access a feature flag value
 * @example const enabled = useFeatureFlag('fpCarrierPortal')
 */
export const useFeatureFlag = (keyName: featureFlagKeys): boolean => {
  const { getFlag } = useFeatureFlagContext()
  const { enabled } = getFlag(keyName)
  return enabled
}
